import { PayoutFrequencyEnum } from 'generated/graphql';

export const payoutFrequencyObjectVacancyList = [
  { id: PayoutFrequencyEnum.Week, name: 'Раз в неделю' },
  { id: PayoutFrequencyEnum.TwoWeek, name: 'Раз в две недели' },
  { id: PayoutFrequencyEnum.Month, name: 'Раз в месяц' },
];
